import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthProvider';
// import { LoginUser } from '../../Services/LoginApi';
import { setItemInStorage } from '../../storage/Storage';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { IconButton, InputAdornment, TextField,Typography } from '@mui/material';
import LoginBackgorund from '../../Asset/image/login-1440.png';
import LoginVectorDown from '../../Asset/image/login_icon1.png';
import LoginVectorUp from '../../Asset/image/login_icon2.png';
import MainLogo from '../../Asset/svg';
import { MailIcon, LoginLock, LoginEye, LoginEyeOff, AppLogoNew } from '../../Asset/svg';
import CustomButton from '../../Components/CommonComp/Buttons/CustomButton';
import CustomInput from '../../Components/CommonComp/CustomInput/CustomInput';
import { loginItemsSelector, setUserDetails } from '../../redux/login';
import { useDispatch, useSelector } from 'react-redux';
import ForgotPasswordModal from '../../Components/Modals/ForgotPasswordModal';
import { LoginUser } from '../../Services/LoginApi';
import { BackgroundImageNoRedux } from '../../Services/commonService';

const LoginLayout = () => {
  const { user, login } = useAuth();
  const [isPassVisible, setIsPassVisible] = useState(false);
  // const [loading, setLoading] = useState(false);
  const { loading } = useSelector(loginItemsSelector);
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [image,setImage]=useState('');

  const navigate = useNavigate();
  useEffect(() => {
    if (user) {
      dispatch(setUserDetails(user))
      navigate('/dashboard');
    }
  }, [user]);

  useEffect(()=>{
    backgrorundImageData();
  },[])

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogin = async (values, { resetForm }) => {
    try {
      const payload = {
        user_name: values?.user_name,
        password: values?.password,
      };
      dispatch(LoginUser(payload, login))
    } catch (e) {
      console.log(e, 'error');
    }
  };

  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };
  const handleClickShowPassword = () => {
    setIsPassVisible(!isPassVisible);
  };

  const backgrorundImageData = async () => {
  let data = await BackgroundImageNoRedux();
  if (data && data?.key_value) {
    const timestamp = new Date().getTime(); // Get current timestamp
    const imageUrlWithTimestamp = `${data.key_value}?t=${timestamp}`; // Append timestamp
    setImage(imageUrlWithTimestamp);
  }
}

  const formik = useFormik({
    initialValues: {
      user_name: '',
      password: '',
    },
    validationSchema: Yup.object({
      user_name: Yup.string()
        .email('Please enter your email')
        .required('Please enter your email'),
      password: Yup.string().required('Please enter your password'),
    }),
    onSubmit: handleLogin,
  });
  return (
    <>
      <img
        // src={LoginBackgorund}
        src={image?image:LoginBackgorund}
        alt="login_backgorund"
        className="login-background"
      />
      <div className="main-login-page">
        <div className="login-section">
          <div className="login-div">
            <img src={LoginVectorUp} className="login-vector-up" />
            {/* <img src={LoginVectorDown} className="login-vector-down" /> */}
            <form onSubmit={formik.handleSubmit} noValidate>
              <div className="login-logo-section">
                <Link to="/">
                  {/* <img src={MainLogo} className="login-logo-image" /> */}
                  <AppLogoNew style={{
                    maxWidth: 210,
                    maxHeight: 45,
                    width: '100%'
                  }} />
                </Link>
              </div>
              <div className="mainpagetitle title-login">
                Continue with Admin Sign In
              </div>
              <div className="login-main-form">
                <div className="login-form-content">
                <CustomInput 
                  label="Email"
                    className="main-login-form"
                    fullWidth
                    id="email"
                    name="email"
                    placeholder="Email Address"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MailIcon className="loginform-field-icons" />
                        </InputAdornment>
                      ),
                    }}
                    value={formik.values.user_name}
                    onChange={(e) => {
                      formik.setFieldValue('user_name', e.target.value);
                    }}
                    error={
                      formik.touched.user_name &&
                      Boolean(formik.errors.user_name)
                    }
                    helperText={
                      formik.touched.user_name && formik.errors.user_name
                    }
                />
                </div>
                <div className="login-form-content login-space-divider">
                <CustomInput 
                    label="Password"
                    className="main-login-form"
                    fullWidth
                    id="password"
                    name="password"
                    type={isPassVisible ? 'text' : 'password'}
                    placeholder="Password"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LoginLock className="loginform-field-icons" />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {isPassVisible ? (
                              <LoginEyeOff className="loginform-field-icons login-eye-icon" />
                            ) : (
                              <LoginEye className="loginform-field-icons login-eye-icon" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    value={formik.values.password}
                    onChange={(e) => {
                      formik.setFieldValue('password', e.target.value);
                    }}
                    error={
                      formik.touched.password && Boolean(formik.errors.password)
                    }
                    helperText={
                      formik.touched.password && formik.errors.password
                    }
                  />
                </div>
              </div>
              {/* <div className="forgot-pass-div-login">
                <button
                  type="button"
                  className="mainsectiontitle forgot-pass-login"
                  onClick={handleClickOpen}
                >
                  Forgot Password?
                </button>
              </div> */}
              <div className="forgot-pass-div-login">
                <Typography
                  component="div"
                  sx={{ marginTop: "20px" }}
                  variant="mainsectiontitle"
                  className="forgot-pass-login secondaryColor boldFont animationLink"
                  onClick={handleClickOpen}
                >
                  Forgot Password?
                </Typography>
              </div>
              <div className="signin-button-main">
              <CustomButton
                  fullWidth
                  sx={{
                    padding: '20px 10px',
                    marginRight: 1,
                    fontSize: '18px',
                    bgcolor: '#000',
                    color: 'buttonSecondary.contrastText',
                    '&:hover':{
                      bgcolor: '#d6d6d6',
                      color: '#000',
                    }
                  }}
                  loading={loading}
                  type="submit"
                >
                  Sign In
                </CustomButton>
              </div>
             
            </form>
          </div>
        </div>
      </div>
     
      <ForgotPasswordModal open={open} onClose={handleClose} />
    </>
  );
};

export default LoginLayout;
